/* eslint-disable no-param-reassign */
/* eslint-disable default-param-last */
import { createSlice } from '@reduxjs/toolkit';

const init = {
  x: 0,
  dragging: false,
  scrollIndex: -1,
};

// Slice
const thumbslider = createSlice({
  name: 'thumbslider',
  initialState: init,
  reducers: {
    setX: (state, action) => {
      state.x = action.payload;
    },
    setDragging: (state, action) => {
      state.dragging = action.payload;
    },
    requestScrollToView: (state, action) => {
      state.scrollIndex = action.payload;
    },
  },
});

export default thumbslider;
